import { EquipmentColumnKeys } from '../../../../app/pages/resources/equipment/enums/equipment-column-keys.enum';
import { WarningLevel } from '../../../../app/shared/enums/warning-level.enum';
import { ThemeKey } from '../../../theme-key.enum';
import { Theme } from '../../../theme.contract';

export const OSP_LIGHT: Theme = {
  id: ThemeKey.OSP_LIGHT,
  icon: 'fa-sun-bright fa-solid fa-fw',
  label: 'OSP Light',
  path: 'src/whitelabel/osp/themes/osp-light/theme.scss',
  pathVariables: 'src/whitelabel/osp/themes/osp-light/_variables.scss',
  defaults: {
    columns: {
      equipmentList: [
        EquipmentColumnKeys.IMAGE,
        EquipmentColumnKeys.CUSTOMER_SERIAL_NUMBER,
        EquipmentColumnKeys.SERIAL_NUMBER,
        EquipmentColumnKeys.MODEL,
        EquipmentColumnKeys.MANUFACTURER_NAME,
        EquipmentColumnKeys.TYPE_CATEGORY2,
        EquipmentColumnKeys.CURRENT_ADDRESS,
        EquipmentColumnKeys.STATUS,
        EquipmentColumnKeys.DETAILS,
      ],
    },
  },
  images: {
    noResultsFound: '/assets/images/not-found/no-results-found-light.svg',
    loadingPlaceholder: '/assets/images/loading/loading-placeholder.png',
    logoSmall: '/assets/images/osp/logo/logo.svg',
    logoFull: 'assets/images/osp/logo/logo-full-light.svg',
  },
  chartColors: {
    theme: 'light',
    backgroundColor: undefined,
    defaultChartColors: [
      '#4EAE30',
      '#C90621',
      '#FFCC00',
      '#277110',
      '#830214',
      '#A68500',
      '#7ED762',
      '#411BEA',
      '#FFD940',
      '#911EB4',
      '#F58231',
      '#42D4F4',
      '#808000',
      '#FFD8B1',
      '#F032E6',
      '#469990',
      '#FABEBE',
      '#FFE119',
      '#8080FF',
      '#ED7651',
      '#808080',
      '#BF40BF',
      '#F0C80E',
      '#362698',
      '#7E7EB8',
      '#008000',
      '#A0A424',
      '#19CB97',
      '#E43E35',
      '#1EAC41',
      '#FF1493',
      '#1E90FF',
    ],
    maintenanceSummaryChartColors: {
      [WarningLevel.OVERDUE]: '#d32f2f',
      [WarningLevel.HIGH]: '#C97A20',
      [WarningLevel.MEDIUM]: '#689f38',
      [WarningLevel.LOW]: '#0288d1',
    },
    unselectedLegendItemColor: '#ff0000',
    coreDataChartColors: ['#14804A', '#BFBFBF'],
    telematicChartColors: ['#689f38', '#AF1814', '#609AF8', '#14804A'],
    telematicInsightColors: ['#689f38', '#AF1814', '#609AF8', '#14804A', '#ff7563'],
  },
  mapColors: [], // default
};
